import React, { Component } from 'react';
import TextFields from './TextFiled';
import Textarea from './Textarea';


class InputTabs extends Component {
    state = {
        [this.props.field]: {
            eng: true,
            arb: false
        }
    };

    componentDidMount(){
        if ((this.props.defaultValue || this.props.defaultValue === 0) && this.props.formApi) {
            this.props.formApi.setValue(`${this.props.value}_en`, this.props.defaultValue);
            this.props.formApi.setValue(`${this.props.value}_ar`, this.props.defaultValue);
        }
    }

    toggleTabsHandler = isEng => {
        this.setState({ [this.props.field]: {arb: !isEng, eng: isEng} })
    };


    render() {
        const { field, label, value } = this.props;
        let fields = (
            <React.Fragment>
                <TextFields hide={ this.state[field].arb }
                            heightSize="60px"
                            validations={this.props.validations}
                            defaultValue={ this.props.defaultValue }
                            type="text"
                            label={ label }
                            field={ `${value}_en` }
                            formApi={this.props.formApi}/>

                <TextFields arb
                            hide={ this.state[field].eng }
                            heightSize="60px"
                            defaultValue={ this.props.defaultValue }
                            validations={this.props.validations}
                            type="text"
                            label={ label }
                            field={ `${value}_ar` }
                            formApi={this.props.formApi}/>

            </React.Fragment>
        );

        if (this.props.textarea ) {
            fields = (
                <React.Fragment>
                    <Textarea formApi={this.props.formApi} tab hide={ !this.state[field].eng } defaultValue={ this.props.defaultValue } validations={this.props.validations} type="text" field={ `${value}_en` }/>
                    <Textarea formApi={this.props.formApi} tab arb hide={ !this.state[field].arb } defaultValue={ this.props.defaultValue } validations={this.props.validations} type="text" field={ `${value}_ar` }/>
                </React.Fragment>
            );
        }

        const activeClassNameEng = this.state[field].eng ? 'active': '';
        const activeClassNameArb = this.state[field].arb ? 'active': '';


        const { errors } = this.props.formApi;
        const errorClassNameEng = ( errors && errors[`${value}_en`] ) ? 'tab-error': '';
        const errorClassNameArb = ( errors && errors[`${value}_ar`] ) ? 'tab-error' : '';

        const classNamesEn = activeClassNameEng +' '+ errorClassNameEng;
        const classNamesAr = activeClassNameArb +' '+ errorClassNameArb;
        return (
            <div className="tab-style">
                <ul className="tab-header">
                    <li className={ classNamesEn }
                        onClick={() => this.toggleTabsHandler(true) }>
                        <a>Eng</a>
                    </li>
                    <li className={ classNamesAr }
                        onClick={() => this.toggleTabsHandler(false) }>
                        <a>Arb</a>
                    </li>
                </ul>
                <div>{ fields }</div>
            </div>
        );
    }
}



export default InputTabs;


// WEBPACK FOOTER //
// ./src/components/UI/InputTabs.js